import { useRef } from "react"
import { useToggleState } from "react-stately"
import { useToggleButton } from "react-aria"
import styled from "@emotion/styled"

import { useDictionary } from "contexts/Dictionary"

import { buttonReset } from "css/buttons"
import { legend80, bold } from "css/text"

import { Icon } from "components/icon/Icon"

const ToggleButton = styled.button`
  ${buttonReset}
  display: grid;
  grid-template-rows: 26px auto;
  padding: 0.5rem;
  transition: color 300ms;
  align-items: center;
  justify-items: center;

  svg {
    align-self: center;
  }

  p {
    ${legend80}
    ${bold}
      margin-top: 0.5rem;

    @media screen and (max-width: 480px) {
      display: none;
    }
  }
  .no-js & {
    display: none;
  }

  @media (hover: hover) {
    :hover {
      color: rgb(var(--green));

      .dark-theme & {
        color: rgb(var(--grey));
      }
    }
  }
`

export default function ToggleNighttime(props) {
  const rbutton = useRef()
  const state = useToggleState(props)
  const { buttonProps } = useToggleButton(props, state, rbutton)
  const dictionary = useDictionary()

  return (
    <ToggleButton {...buttonProps} aria-label={props.ariaLabel} ref={rbutton}>
      <Icon size='18' type={state.isSelected ? "day" : "night"} />
      <p>{!state.isSelected ? dictionary.viewNightMode() : dictionary.viewDayMode()}</p>
    </ToggleButton>
  )
}
